import script from "./CompanyProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyProfileView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyProfileView.vue?vue&type=style&index=0&id=50f70905&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f70905"]])

export default __exports__